import { type INameInputUiProps, NameInputUi } from 'features/CreateOrEdit/NameInput/ui/NameInputUi'
import { NameInputContext } from 'features/CreateOrEdit/NameInput/context/context'
import { type NameInputStore } from 'features/CreateOrEdit/NameInput/store/nameInputStore'

export type INameInputProps = {
  store: NameInputStore
} & INameInputUiProps

export const NameInput = ({ store, ...props }: INameInputProps) => {
  return (
    <NameInputContext.Provider value={store}>
      <NameInputUi {...props} />
    </NameInputContext.Provider>
  )
}
